// getViewScopeUserKey.js
'use strict';
import { createSelector } from '../resource/createCachedSelector.js';

import getMeData from '../selector/getMeData.js';

const VISITOR_USER_KEY = 'visitor';

/**
 * Select the key that a message view scope is stored under.
 * Media permission only applies to the identity that fetched it, so the answer
 * is kept per identity: a visitor gets its own key instead of sharing whatever
 * the previously logged in user saw.
 * Both the readers and the writers of `message.viewScope` must go through here,
 * otherwise an answer gets written under one key and read under another.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {string} The current user id, or the visitor key when not logged in.
 * @example
 * getViewScopeUserKey(state);
 * // => 'user-1' when logged in
 * // => 'visitor' when not logged in
 */
const getViewScopeUserKey = createSelector(
  state => getMeData(state, 'id'),
  meId => meId || VISITOR_USER_KEY
);

export default getViewScopeUserKey;
export { VISITOR_USER_KEY };
